/*Validation Repository: This file will be the repository of all application Validations */
/* Add endDate, endTime Mar 13, 2022 */
import {fn_AsyncGET} from "@/utils/api.js";

// Every validateFn must return a promise as designed here.
var validations=[
                 {	validationCode:'checkProjectNo',
					description: 'Check for duplicate Project Number',
					errorMessage:  value=>{return`The Project Number ${value} is already used`},
					validationFn: value => { //fn_getProjectNo({projectNo: value})
					return fn_AsyncGET('getProjectNo',{projectNo: value});
											}
				},
				{	validationCode:'endTime',
					description: 'Check for valid end time',
					validationFn: value => { 
					var valid=value.endTime >value.startTime;
					var errorMessage=valid?null:`The end time must be after the start time`
					return ({valid:valid,errorMessage:errorMessage })
											}
				},
				{	validationCode:'endDate',
					description: 'Check for valid end date',
					validationFn: value => { 
					var valid=value.endDate >=value.startDate;
					var errorMessage=valid?null:`The end date must be on or after the start date`
					return ({valid:valid,errorMessage:errorMessage })
											}
				},
			];


//validation execution function
function fn_validate(validationCode,value){
var validation=validations.find(v => v.validationCode == validationCode);
return validation.validationFn(value);
}
function fn_errorMsg(validationCode, value) {
	return validations.find(v => v.validationCode == validationCode).errorMessage(value);
	}


export {
	fn_validate,
	fn_errorMsg,
};
